// removed by extract-text-webpack-plugin
module.exports = {"item":"_3cvlDO-na81quhAsfjsgYv","content":"_2c5z6DSpjJbKtBOpW8W_Wd","name":"_2_aMy7lgGE1C914BwgVYgC","id":"_2GqLo_2gZpxNp84GeczHEb","time":"_3tgXhvkrSQv0wyIO4cxnQ8"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/CustomersProfiles/ListItem.module.css
// module id = 2340
// module chunks = 1